import type { Location } from '@api/locations/locations';
import { EStyles } from '@enums/style.enum';
import { LocationType } from '@enums/trips.enum';
import type { Trip } from '@store/trips/tripsSlice';

export const handleGetLocationFromPoint = (point: Trip['from'] | Trip['to'], locations: Location[]) => {
	// Check if point location is within radius 30 of any location
	const radius = 30; // meters

	const getDistance = (lat1: number, lng1: number, lat2: number, lng2: number) => {
		const toRad = (value: number) => (value * Math.PI) / 180;
		const R = 6371e3; // meters
		const dLat = toRad(lat2 - lat1);
		const dLng = toRad(lng2 - lng1);
		const a =
			Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
		const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
		return R * c; // return distance in meters
	};

	// Find the first location within radius
	const foundLocation = locations.find((loc) => {
		const dist = getDistance(point.lat, point.lng, loc.lat, loc.lng);
		return dist <= radius;
	});

	return foundLocation
		? { ...point, displayName: foundLocation.name, type: foundLocation.type }
		: { ...point, displayName: point.name.split(EStyles.comma)[0], type: LocationType.Default };
};
